import Loader from './Loader';

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader/index.js